import "bulma/css/bulma.css";

var frames = [
  new URL("./sprite/pulse1.png", import.meta.url).href,
  new URL("./sprite/pulse2.png", import.meta.url).href,
  new URL("./sprite/pulse3.png", import.meta.url).href,
  new URL("./sprite/pulse4.png", import.meta.url).href,
  new URL("./sprite/pulse5.png", import.meta.url).href,
  new URL("./sprite/pulse6.png", import.meta.url).href
];

// Speed curve: slow start, speed up, slow landing on the logo
var timing = [
  600,   // frame 1 — hold the opening beat
  420,   // frame 2 — easing in
  280,   // frame 3 — picking up
  220,   // frame 4 — fastest
  350,   // frame 5 — braking
  500    // frame 6 — settle on the logo
];

function preloadFrames(callback) {
  var remaining = frames.length;

  frames.forEach(function (src) {
    var img = new Image();
    img.onload = img.onerror = done;
    img.src = src;
    if (img.complete) {
      done();
    }
  });

  function done() {
    remaining--;
    if (remaining <= 0) {
      callback();
    }
  }
}

function runAnimation() {
  var sprite = document.getElementById("sprite");
  var subtitle = document.querySelector(".subtitle");

  sprite.classList.remove("visible", "heartbeat");
  subtitle.classList.remove("visible");

  preloadFrames(function () {
    var currentFrame = 0;
    sprite.src = frames[0];
    sprite.classList.add("visible");

    function nextFrame() {
      currentFrame++;
      if (currentFrame >= frames.length) {
        sprite.src = frames[frames.length - 1];
        sprite.classList.add("heartbeat");
        setTimeout(function () {
          subtitle.classList.add("visible");
        }, 500);
        return;
      }
      sprite.src = frames[currentFrame];
      setTimeout(nextFrame, timing[currentFrame]);
    }

    setTimeout(nextFrame, timing[0]);
  });
}

document.addEventListener("DOMContentLoaded", runAnimation);
